import styles from './GalleryItem.module.scss';
import cn from 'classnames';
import { Backdrop } from '@/atoms/Backdrop';
import { BACKEND_URL } from '@/constants';
import { parseText } from '@/utils/parseText';

type GalleryItemProps = {
  name?: string;
  item: string;
  className?: string;
  gallery?: boolean;
  alert?: {
    name: string;
    icon?: string;
  };
  unaccompanied?: string;
  accompanied?: string;
};

export function GalleryItem({
  name,
  item,
  className,
  gallery,
  alert,
  unaccompanied,
  accompanied,
}: GalleryItemProps) {
  const cardClassName = cn(
    styles.banner,
    {
      [styles.gallery]: gallery,
    },
    className,
  );

  const getGalleryItemBackgroundTag = () => {
    if (item.endsWith('.mp4')) {
      return (
        <video className={styles.img} autoPlay loop muted playsInline>
          <source src={`${BACKEND_URL}${item}`} type="video/mp4" />
        </video>
      );
    }

    return (
      <img
        loading="lazy"
        src={`${BACKEND_URL}${item}`}
        alt="object"
        className={styles.img}
      />
    );
  };

  const getBackdropHeight = () => {
    if (name && alert) return 210;

    if (name && !alert) return 100;

    return 0;
  };

  return (
    <div className={cardClassName}>
      {getGalleryItemBackgroundTag()}
      <div></div>
      <div className={styles.info}>
        <div className={styles.container}>
          <div className={styles.titleWrapper}>
            {alert && (
              <div className={styles.alert}>
                {alert.icon && (
                  <img
                    loading="lazy"
                    src={`${BACKEND_URL}${alert.icon}`}
                    alt="info"
                    className={styles.alertImg}
                  />
                )}
                <span className={styles.alertText}>{alert.name}</span>
              </div>
            )}
            {gallery ? (
              <div className={cn(styles.titleBig, 'custom-gallery-title')}>
                {parseText(name)}
              </div>
            ) : (
              <div className={cn(styles.title, 'custom-gallery-title')}>
                {parseText(name)}
              </div>
            )}
          </div>
          <div className={styles.companyWrapper}>
            {accompanied && (
              <div className={styles.accompanied}>
                <img
                  src="/svg/family.svg"
                  alt="accompanied"
                  className={styles.companyIcon}
                />
                <span className={styles.companyText}>
                  {parseText(accompanied)}
                </span>
              </div>
            )}
            {unaccompanied && (
              <div className={styles.unaccompanied}>
                <img
                  src="/svg/adult.svg"
                  alt="unaccompanied"
                  className={styles.companyIcon}
                />
                <span className={styles.companyText}>
                  {parseText(unaccompanied)}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      {name && <Backdrop height={getBackdropHeight()} />}
    </div>
  );
}
